const MESSAGING = {
	VOTER_INTERACTION_MESSAGING: 'voter_interaction_messaging',
} as const;

export const ACTIONS_VOTER_INTERACTION = {
	VOTER_INTERACTION: 'voter_interaction',
	...MESSAGING,
} as const;
